import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faInstagram, faTwitter, IconDefinition } from '@fortawesome/free-brands-svg-icons';
import profile from '../profile.json';
import { Profile } from '../types/profile';

type SocialMediaType = 'github' | 'linkedin' | 'twitter' | 'instagram';

interface SocialMediaIconProps {
    type: SocialMediaType;
    hyperlink?: string;
}

const typedProfile = profile as Profile;

export default function SocialMediaIcon({ type, hyperlink }: SocialMediaIconProps): React.ReactElement {
    const iconTypes: Record<SocialMediaType, IconDefinition> = {
        'linkedin': faLinkedin,
        'github': faGithub,
        'instagram': faInstagram,
        'twitter': faTwitter
    };

    const icon = iconTypes[type];
    const URL = hyperlink || typedProfile['social-media-links'][type];

    return (
        <motion.a 
            href={URL} 
            target='_blank' 
            rel='noreferrer' 
            className="social-icon"
            aria-label={type}
            whileHover={{ y: -4 }}
            whileTap={{ scale: 0.95 }}
        >
            <FontAwesomeIcon icon={icon} />
        </motion.a>
    );
}
